import { render } from "./CustomerReviewsComponent.vue?vue&type=template&id=40d8b8c5&scoped=true"
const script = {}

import "./CustomerReviewsComponent.vue?vue&type=style&index=0&id=40d8b8c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d8b8c5"]])

export default __exports__